import { useEffect } from 'react';

export type EngineeringAIContext = {
  scope: 'builder' | 'schedule';
  design_id?: number;
  name?: string;
  stages: Array<{ stage_number: number; [key: string]: unknown }>;
  [key: string]: unknown;
};

export function useEngineeringAIContext(projectId: number | undefined, context: EngineeringAIContext) {
  useEffect(() => {
    const listener = (event: Event) => {
      const detail = (event as CustomEvent).detail;
      if (projectId === detail.projectId && context.scope === detail.scope) detail.respond(context);
    };
    window.addEventListener('fracsight-engineering-context', listener);
    return () => window.removeEventListener('fracsight-engineering-context', listener);
  }, [projectId, context]);
}

export function readEngineeringAIContext(projectId: number, scope: string) {
  let context: EngineeringAIContext | undefined;
  window.dispatchEvent(new CustomEvent('fracsight-engineering-context', {
    detail: { projectId, scope, respond: (value: EngineeringAIContext) => { context = value; } },
  }));
  return context;
}
